import React from "react"
import { PreferencesContext } from "../PreferencesProvider"

export function useGetPref(): (name: string) => string | undefined {
  const context = React.useContext(PreferencesContext)
  if (context === undefined) {
    throw new Error("useGetPref must be used within a PreferencesProvider")
  }
  return context.getPref
}

export function useSetPref(): (name: string, value: string) => void {
  const context = React.useContext(PreferencesContext)
  if (context === undefined) {
    throw new Error("useSetPref must be used within a PreferencesProvider")
  }
  return context.setPref
}
